import RankBase from "../RankBase";
import Notice from "../Notice";
import ServiceRepair from "../../../error/ServiceRepair";

const PLACE_RANK_TYPE = 'ST002'

const notices = [
    { text: '무료 회원은 3개까지 무료 등록이 가능합니다. (회원정보 사용 슬롯 참고)', style: { color: 'red' } },
    { text: '쇼핑 상품명 입력은 띄어쓰기까지 정확하게 입력시 순위체크가 가능합니다. (쇼핑 상품명과 동일한 상호명)' },
    { text: '매일 순위 체크는 11시 부터 순차적으로 순위 업데이트 진행 합니다.' },
    { text: '순위 이력은 최근 3개월 내역까지 저장이되며, 3개월 경과건은 순차적으로 삭제 될 수 있습니다.' },
    { text: '300위까지 체크됩니다.' },
    { text: '순위 표시에 나오는 표시항목은 별점, 리뷰갯수, 구매갯수, 찜갯수 입니다.' },
    { text: '리 = 리뷰갯수 / 구 = 구매갯수 / 찜 = 찜갯수' }
]

const ShoppingNotice = () => ( <Notice notices={notices} /> );   

const shoppingRank = props => {
    return (
        <RankBase notice={ShoppingNotice} type={PLACE_RANK_TYPE} />
        // <ServiceRepair />
    )
}

export default shoppingRank;
